import { ChevronDownIcon } from "@/components/ui/icon";
import { Select, SelectTrigger, SelectInput, SelectIcon, SelectPortal, SelectContent, SelectItem } from "@/components/ui/select";
import { Text } from "@/components/ui/text";
import i18n from 'i18n-js';
import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import ModalBase from './ModalBase';
import saving from '../../algorithms_and_functions/backend_requests/saving';
import { backendRequest } from '@/stores/thunks';

export default function ModalGift({ showModal, setShowModal, tasks }) {

    const [task, setTask] = useState(0)
    const [profile, setProfile] = useState(0)

    const categories = ['taskSettings.home', 'taskSettings.garden', 'taskSettings.allday', 'taskSettings.medic', 'taskSettings.diy', 'taskSettings.cook', 'taskSettings.other'].map(cat => i18n.t(cat))
    const [category, setCategory] = useState((+tasks[task]?.settings.category || 7) - 1)
    const dispatch = useDispatch()

    const onClose = (isOk) => {
        setShowModal(false)
        if (isOk) {
            donateTask()
        }
    }

    const selectTask = (newTask) => {
        console.log('ZZZ', tasks[newTask]?.settings.category, (+tasks[newTask]?.settings.category || 7) - 1)
        setTask(newTask)
        setCategory((+tasks[newTask]?.settings.category || 7) - 1)
        setProfile(tasks[newTask].settings.profile || 0)
    }

    async function donateTask() {
        const marketBase = { ...tasks[task], settings: { ...tasks[task].settings, category: category + 1, profile: profile } };
        console.log('SAVE', marketBase)
        await saving(marketBase)

        const response = await dispatch(backendRequest('STUDIO_DONATE', '/market', {
            workflowId: tasks[task].id,
            stats: JSON.stringify({ category: +category + 1 }),
            anonymous: profile == 1
        }, 'POST', false))
        console.log('DONATE', response)
    }

    function Selection({ title, selected, setSelected, selections }) {
        return (
            <>
                <Text className="font-[400] text-lg text-secondary-900">{i18n.t(title)}</Text>
                <Select accessibilityLabel={i18n.t(title)} onValueChange={itemValue => setSelected(itemValue)} className="bg-secondary-50">
                    <SelectTrigger variant="outline" className='border-secondary-900'>
                        <SelectInput className="text-lg" placeholder={i18n.t(title)} value={selections[selected]} />
                        <SelectIcon className="absolute right-3 text-secondary-900" as={ChevronDownIcon} />
                    </SelectTrigger>
                    <SelectPortal>
                        <SelectContent>
                            {selections.map((key, k) => <SelectItem key={k} label={key} value={k} />)}
                        </SelectContent>
                    </SelectPortal>
                </Select>
            </>
        );
    }

    return (
        <ModalBase showModal={showModal} setShowModal={onClose} title={'studio.market.giftTitle'} info={'studio.market.giftInfo'} onButton={onClose} buttonR={'studio.market.giftSend'} buttonL={'workflowsScreen.cancel'}>
            <Selection title='studio.market.giftTaskHeader' selected={task} setSelected={selectTask} selections={tasks.map(task => task.title || i18n.t('studio.main.noTitle'))} />
            <Text className="font-[400] text-lg text-secondary-900">{i18n.t('studio.market.giftTextHeader')}</Text>
            <Text className="font-[400] text-lg text-secondary-900 border border-secondary-900 rounded-[4px] p-2">{tasks[task]?.text}</Text>
            <Selection title='shareQRCode.actProfile' selected={profile} setSelected={setProfile} selections={[i18n.t('shareQRCode.profile'), i18n.t('shareQRCode.public')]} />
            <Selection title='taskSettings.category' selected={category} setSelected={setCategory} selections={categories} />
        </ModalBase>
    );
}